import { Avatar } from 'features/account/Avatar/Avatar';
import Modal from 'honeydew/Modal';
import { useAccountPlusMembershipHook } from 'hooks/useAccountPlusMembershipHook';

/**
 * AvatarModal component displays a modal with an avatar icon and a message
 * celebrating the user's one year anniversary as a member of the paid membership.
 *
 * @param {Object} props - Component props
 * @param {Function} props.onClose - Function to close the modal
 * @param {boolean} props.open - Whether the modal is open
 * @returns {JSX.Element} A modal component with an avatar icon and a message
 */
export function AvatarModal({ onClose, open }) {
    const { plusMembershipBranding } = useAccountPlusMembershipHook();

    return (
        <Modal
            onClose={onClose}
            open={open}
            bgColor="bg-plus-membership-gradient"
            includeHorizontalPadding={false}
            styles={{
                contentRoot:
                    'max-w-[400px] justify-center max-w-[540px] items-center my-auto rounded-lg mx-20 outline-none',
            }}
        >
            <div className="space-y-20 px-20 pt-10 md:px-60">
                <div className="flex flex-col items-center justify-center text-center">
                    <h1 className="text-heading-xs mb-10 px-20 md:text-heading-desktop-xs">
                        You&apos;ve officially leveled up!
                    </h1>
                    <p className="text-body-md">
                        Enjoy your new avatar that celebrates your first {plusMembershipBranding} anniversary—and even
                        more savings and impact to come.
                    </p>
                    <div className="mt-20 flex justify-center rounded-lg bg-white bg-opacity-60 p-10 md:flex md:w-[240px] md:flex-col md:py-20">
                        <Avatar />
                    </div>
                </div>
            </div>
        </Modal>
    );
}
